<template>
  <div class="footer-container" id="footer">
    <div class="footer-content container">
      <div class="eyejack-app">
        <img
          id="footer-logo"
          src="../assets/footer-logo-white.png"
          alt="EyeJack"
        />
      </div>
      <div class="footer-fields">
        <div class="field-names">
          <div class="fields">
            <ul id="footer-1">
              <li>
                <a class="field-title">Creator</a>
              </li>

              <li>
                <a target="_blank" href="https://eyejackapp.com/pages/hot-tips"
                  >Hot Tips</a
                >
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://eyejackapp.com/pages/ar-animations"
                  >AR Animations</a
                >
              </li>
              <!-- <li>
                <a target="_blank" href="https://eyejackapp.com/pages/panels"
                  >Panels Tutorial</a
                >
              </li> -->
            </ul>
          </div>
          <!-- <div class="fields">
            <ul id="">
              <li>
                <a class="field-title"><br /></a>
              </li>
              <li>
                <a target="_blank" href="https://eyejackapp.com/pages/murals"
                  >Capturing Murals</a
                >
              </li>
              <li>
                <a target="_blank" href="https://eyejackapp.com/pages/listings"
                  >Listings</a
                >
              </li>
              <li>
                <a target="_blank" href="https://eyejackapp.com/pages/support"
                  >Support</a
                >
              </li>
            </ul>
          </div> -->
          <!-- <div class="fields">
            <ul id="">
              <li>
                <a class="field-title">Web AR</a>
              </li>
              <li>
                <a target="_blank" href="http://webar.eyejackapp.com/"
                  >WebAR Demo</a
                >
              </li>
              <li>
                <a target="_blank" href="https://eyejackapp.com/pages/8thwall"
                  >8th Wall Integration</a
                >
              </li>
            </ul>
          </div> -->
        </div>

        <div class="field-partners">
          <div class="fields">
            <p class="field-title">Partners</p>
            <ul id="partners">
              <!-- <li id="partner-1">
                <a target="_blank" href="http://codeoncanvas.cc"
                  ><img src="../assets/COC.png" alt="Code on Canvas"
                /></a>
              </li> -->
              <li id="partner-2">
                <a target="_blank" href="https://8thwall.com"
                  ><img src="../assets/8th-wall.png" alt="8th Wall"
                /></a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <hr class="footer-hr" />
      <div class="footer-end">
        <div class="social-links">
          <a target="_blank" href="https://www.instagram.com/eyejackapp/">
            <img
              id="ig-link"
              src="../assets/instagram-white.png"
              alt="Instagram"
            />
          </a>
          <a target="_blank" href="https://www.facebook.com/eyejackapp/">
            <img
              id="fb-link"
              src="../assets/facebook-white.png"
              alt="Facebook"
            />
          </a>
          <a target="_blank" href="mailto:info@eyejackapp.com">
            <img id="mail-link" src="../assets/mail-white.png" alt="Email" />
          </a>
        </div>
        <div class="footer-copy">
          <ul>
            <li>© 2021 EyeJack. All rights reserved.</li>
            <li>
              <a
                target="_blank"
                id="terms"
                href="https://eyejackapp.com/pages/terms"
                >Terms</a
              >
            </li>
            <li>
              <a
                target="_blank"
                id="privacy"
                href="https://eyejackapp.com/pages/privacy"
                >Privacy</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss" scoped>
@import "../styles/styles.scss";

.footer-hr {
  width: 100%;
  background-color: #575757;
}
.footer-container {
  background: #0d0d0d;
  font-size: 0.8125em;
  .footer-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: #ffffff;
  }
  #footer-logo {
    width: 70px;
    margin-bottom: 40px;
  }
  .footer-fields {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    margin: 0 0 20px 0;
    .field-names {
      display: flex;
      flex: 0 0 100%;
      justify-content: space-between;
    }

    .fields {
      margin-top: 2em;
      margin-right: 1em;
      letter-spacing: 1.55px;
    }

    .field-title {
      font-size: 1em;
      color: #ffffff;
      font-weight: 700;
      line-height: 18.75px;
      padding-bottom: 10px;
    }
    ul {
      padding: 0;
      li {
        padding-bottom: 20px;
        list-style-type: none;
        margin: 0;
        text-align: left;
        a {
          color: #9e9e9e;
          font-weight: 400;
          line-height: 18.75px;
          text-decoration: none;
        }
        a:hover {
          color: #ffffff;
        }
      }
    }
    #creator {
      columns: 2;
      list-style-position: inside;
    }
    #partners {
      display: flex;
      align-items: baseline;
      width: 80%;
      padding-top: 0;
      #partner-1 {
        width: 50px;
        margin-right: 40px;
      }
      #partner-2 {
        width: 125px;
      }
    }
  }
  .footer-end {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 40px;

    .footer-copy {
      display: flex;
      align-items: center;
      ul {
        display: flex;
        flex-wrap: wrap;
      }
    }
    .social-links {
      display: flex;
      align-items: center;
      flex: 1 0 50%;
      #fb-link,
      #ig-link,
      #mail-link {
        width: 30px;
        margin-right: 2em;
      }
    }
    .footer-copy {
      p,
      li {
        margin-left: 1em;
        line-height: 1.5;
        letter-spacing: 1.55px;
        font-weight: 400;
        color: #9e9e9e;
        font-size: 1em;
      }
      a {
        color: #9e9e9e;
      }
      a:hover {
        color: #ffffff;
      }
    }
  }
  #footer-1 {
    flex-direction: column;
    justify-content: space-between;
  }
}

@include media(">=phone-lg") {
  .footer-container {
    .footer-fields {
      .fields {
        margin-top: 0;
      }
      #partners {
        width: 100%;
        padding-top: 40px;
      }
    }
  }
}
@include media(">=tablet") {
  .footer-container {
    .eyejack-app {
      #footer-logo {
        margin-bottom: 60px;
      }
    }

    font-size: 1em;
    .footer-fields {
      .field-names {
        flex: 0 0 65%;
      }
    }
  }
}

@include media(">=desktop") {
  .footer-container {
    .footer-fields {
      .field-names {
        flex: 0 0 50%;
      }
    }
  }
}
</style>